import { useEffect } from 'react'
import { TopBarProps } from './Types'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { MoreDots as MoreDots24 } from 'blaze-ui/icons/24'
import { MobileTopBarContainer } from 'blaze-components/MobileTopBarContainer'
import { DesignMenuDrawer } from 'components/DesignMenu/DesignMenuDrawer'
import { track } from '@tldraw/tldraw'
import { Button as MobileButton } from 'common/Prose/Toolbar/ToolbarBravo/WriterFormatToolbar/Button'
import { FlipLeft, FlipRight } from 'blaze-ui/icons'
import { useActions } from 'components/VisualStudioPlayground/VisualEditor/hooks/useActions'
import { CanView } from 'components/Can'
import { UserRole } from 'types'
import { ShareButton } from 'components/Design/TopBar/ShareButton'
import { FinishReviewButton } from 'components/Design/TopBar/FinishReviewButton'
import { compact } from 'lodash'
import { MobilePublishButton } from 'components/Design/Footer/components/MobilePublishButton'

const MobileDesignerTopBar = track(
  observer(({ fileId }: TopBarProps) => {
    const { files, designStore, drawersStore } = useRootStore()

    useEffect(() => {
      files.fetch(fileId)
    }, [files, fileId])

    const file = files.get(fileId)
    const editor = designStore?.editor
    const actions = useActions(editor)

    return (
      <MobileTopBarContainer.Root>
        {file && (
          <>
            <MobileTopBarContainer.Left>
              <MobileTopBarContainer.BackButton />
            </MobileTopBarContainer.Left>
            <MobileTopBarContainer.Center></MobileTopBarContainer.Center>
            <MobileTopBarContainer.Right>
              {editor && (
                <>
                  <MobileButton
                    icon={FlipLeft}
                    aria-label="Undo"
                    onPress={() => actions['undo'].onSelect()}
                    isDisabled={!editor.getCanUndo()}
                  />
                  <MobileButton
                    icon={FlipRight}
                    aria-label="Redo"
                    onPress={() => actions['redo'].onSelect()}
                    isDisabled={!editor.getCanRedo()}
                  />
                </>
              )}
              <MobilePublishButton file={file} />
              <CanView as={[UserRole.MEMBER, UserRole.SUPER_ADMIN, UserRole.ADMIN]} inWorkspace={file.workspace.id}>
                {designStore?.reviewLater ? <FinishReviewButton /> : <ShareButton fileId={file.id} />}
              </CanView>
              <MobileButton
                icon={MoreDots24}
                aria-label="File Menu"
                onPress={() =>
                  drawersStore.openDrawer(DesignMenuDrawer, {
                    id: file.id,
                    hiddenKeys: new Set(
                      compact([
                        'rename',
                        'openInNewTab',
                      ]),
                    ),
                  })
                }
              />
            </MobileTopBarContainer.Right>
          </>
        )}
      </MobileTopBarContainer.Root>
    )
  }),
)

export { MobileDesignerTopBar }
